export { default } from "./PromotionsProducts.jsx";
